export default [
    {
        field: 'hr_employee_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            disabled: true,
            label: 'Empleado',
        },
        options: {
            data: [],
            text: hr_employee => hr_employee.names + ' ' + hr_employee.last_name1 + ' ' + hr_employee.last_name2,
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'hr_absence_request_type_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Tipo ausencia',
        },
        options: {
            data: [],
            text: 'type',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'init_date',
        type: 'datePicker',
        vuetifyProps: {
            label: 'Inicio ausencia',
        },
        rules: ['required'],
    },
    {
        field: 'end_date',
        type: 'datePicker',
        vuetifyProps: {
            label: 'Término ausencia',
        },
        rules: ['required'],
    },
    {
        field: 'description',
        type: 'text',
        vuetifyProps: {
            label: 'Glosa',
            'single-line': true,
            outline: true,
        },
        rules: ['required'],
        value: '',
    },
    {
        field: 'comment',
        type: 'textarea',
        vuetifyProps: {
            label: 'Comentario',
            'single-line': true,
            outline: true,
        },
        rules: ['required'],
        value: '',
    },
]
